import { render, staticRenderFns } from "./addCalendar.vue?vue&type=template&id=a3200174"
import script from "./addCalendar.vue?vue&type=script&lang=js"
export * from "./addCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports